import React, { useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useParams,
} from "react-router-dom";
import withRouter from "utility/with-router";
import SNavbar from "components/commons/Dashboard/SNavbar";
import { DiscoverTabs, ContentTypes, UrlSearchParams } from "types/enums";
import PageProvider, { PAGE_TITLE_SEPARATOR } from "providers/page";
import Schedule from "./pages/schedule/index.tsx";
import Home from "./pages/home";
import Discover from "./pages/discover";
import { WoneIndex } from "apps/user/learner/pages/woneindex";
import WoneIndexDetails from "apps/user/learner/pages/woneindex/details.tsx";
import WoneIndexPillarDetails from "apps/user/learner/pages/woneindex/pillar-details.tsx";
import ArticleDetail from "apps/user/learner/pages/articles/article-detail";
import FavouritesLandings from "pages/users/Favourites/favourites-landings.component";
import JoinSession from "apps/user/learner/pages/joinsession";
import FeedbackByStudentAfterJoinSession from "apps/user/learner/pages/feedback/feedback-by-student-after-join-session";
import NotFound from "components/NotFound";
import Biometrics from "pages/users/Biometrics/biometrics.component";
import ProfilePage from "apps/user/learner/pages/profile/index";
import Settings from "apps/user/learner/pages/settings";
import PractitionerDetail from "apps/user/learner/pages/practitioners/practitioner-detail";
import ContentList from "apps/user/learner/components/content-list";
import OriPage from "apps/user/learner/pages/chat";
import DecemberDoorsPage from "apps/user/learner/pages/december-doors";

import OrangePattern from "Assets/patterns/orange.json";
import RedPattern from "Assets/patterns/red.json";
import BluePattern from "Assets/patterns/blue.json";
import PinkPattern from "Assets/patterns/pink.json";

import { usePatternBackground } from "providers/pattern-background";
import BiometricsModalProvider from "providers/biometrics-modal";
import SessionFeedbackProvider from "providers/SessionFeedback";
import { ContentModalManagerProvider } from "providers/content-modal-manager";
import ContentModalRouter from "components/content-modal/ContentModalRouter";
import FeedbackWidget from "./components/feedback-widget";

import styles from "./styles.module.scss";

// Redirect components using useParams to extract IDs from URLs
const SessionGroupRedirect = () => {
  const { session_id } = useParams();
  const location = useLocation();
  const query = new URLSearchParams(location.search).toString();
  return (
    <Navigate
      to={`/user/discover?${UrlSearchParams.Tab}=${
        DiscoverTabs.LIVE_SCHEDULE
      }&${UrlSearchParams.ContentType}=${ContentTypes.SESSION}&${
        UrlSearchParams.ContentId
      }=${session_id}${query ? `&${query}` : ""}`}
      replace
    />
  );
};

const RecordingRedirect = () => {
  const { recordingId } = useParams();
  const location = useLocation();
  const query = new URLSearchParams(location.search).toString();
  return (
    <Navigate
      to={`/user/discover?${UrlSearchParams.Tab}=${DiscoverTabs.SESSIONS}&${
        UrlSearchParams.ContentType
      }=${ContentTypes.RECORDING}&${UrlSearchParams.ContentId}=${recordingId}${
        query ? `&${query}` : ""
      }`}
      replace
    />
  );
};

const UserRoutes = [
  {
    Title: "Home",
    Exact: true,
    Path: "home",
    Component: Home,
    waitForTitlePrefix: false,
  },
  {
    Title: "Discover",
    Exact: true,
    Path: "discover",
    Component: Discover,
    waitForTitlePrefix: false,
  },
  {
    Title: "My Schedule",
    Exact: true,
    Path: "schedule",
    Component: Schedule,
    waitForTitlePrefix: false,
  },
  {
    Title: "WONE Index",
    Exact: true,
    Path: "woneindex",
    Component: WoneIndex,
    waitForTitlePrefix: false,
  },
  {
    Title: "WONE Index Details",
    Exact: true,
    Path: "woneindex/details",
    Component: WoneIndexDetails,
    waitForTitlePrefix: true,
  },
  {
    Title: "WONE Index",
    Exact: true,
    Path: "woneindex/details",
    Component: WoneIndexPillarDetails,
    waitForTitlePrefix: true,
  },
  {
    Title: "WONE Index",
    Exact: true,
    Path: "woneindex/:woneindexType",
    Component: WoneIndexPillarDetails,
    waitForTitlePrefix: true,
  },
  {
    Title: `Content Lists ${PAGE_TITLE_SEPARATOR} Recordings`,
    Exact: true,
    Path: "recordings/content-lists/:id",
    Component: ContentList,
    waitForTitlePrefix: true,
  },
  {
    Title: `Content Lists ${PAGE_TITLE_SEPARATOR} Articles`,
    Exact: true,
    Path: "articles/content-lists/:id",
    Component: ContentList,
    waitForTitlePrefix: true,
  },
  {
    Title: `Content Lists ${PAGE_TITLE_SEPARATOR} WONE Index`,
    Exact: true,
    Path: "woneindex/content-lists/:id",
    Component: ContentList,
    waitForTitlePrefix: true,
  },
  {
    Title: "Articles",
    Exact: true,
    Path: "articles/:articleId",
    Component: ArticleDetail,
    waitForTitlePrefix: true,
  },
  {
    Title: "Biometrics",
    Exact: true,
    Path: "/user/biometrics",
    Component: Biometrics,
    waitForTitlePrefix: false,
  },
  {
    Title: "Favourites",
    Exact: true,
    Path: "favourites",
    Component: FavouritesLandings,
    waitForTitlePrefix: false,
  },
  {
    Title: "Favourites",
    Exact: true,
    Path: "favourites/:favouriteId",
    Component: FavouritesLandings,
    waitForTitlePrefix: true,
  },
  {
    Title: "Feedback",
    Exact: true,
    Path: "sessions/:sessionType/:sessionId/meeting/feedback",
    Component: FeedbackByStudentAfterJoinSession,
    waitForTitlePrefix: true,
  },
  {
    Title: "Feedback",
    Exact: true,
    Path: "recordings/:recordingId/feedback",
    Component: FeedbackByStudentAfterJoinSession,
    waitForTitlePrefix: true,
  },
  {
    Title: "Meeting",
    Exact: true,
    Path: "sessions/:sessionType/:sessionId/meeting",
    Component: JoinSession,
    waitForTitlePrefix: true,
  },
  {
    Title: "Profile",
    Exact: true,
    Path: "profile",
    Component: ProfilePage,
    waitForTitlePrefix: false,
  },
  {
    Title: "Settings",
    Exact: true,
    Path: "profile/settings",
    Component: Settings,
    waitForTitlePrefix: false,
  },
  {
    Title: "Settings",
    Exact: true,
    Path: "profile/settings/:subnav",
    Component: Settings,
    waitForTitlePrefix: false,
  },
  {
    Title: "Settings",
    Exact: false,
    Path: "profile/settings/calendar/:subnav",
    Component: Settings,
    waitForTitlePrefix: false,
  },
  {
    Title: `Content Lists ${PAGE_TITLE_SEPARATOR} Profile`,
    Exact: true,
    Path: "profile/content-lists/:id",
    Component: ContentList,
    waitForTitlePrefix: true,
  },
  {
    Title: "Practitioners",
    Exact: true,
    Path: "practitioners/:id",
    Component: PractitionerDetail,
    waitForTitlePrefix: true,
  },
  {
    Title: `Content Lists ${PAGE_TITLE_SEPARATOR} Practitioners`,
    Exact: true,
    Path: "practitioners/:practitionerId/content-lists/:id",
    Component: ContentList,
    waitForTitlePrefix: true,
  },
  {
    Title: "Ori",
    Exact: true,
    Path: "chat",
    Component: OriPage,
    waitForTitlePrefix: false,
  },
  {
    Title: "December Doors",
    Exact: true,
    Path: "december-doors",
    Component: DecemberDoorsPage,
    waitForTitlePrefix: false,
  },
  {
    Title: "Page Not Found",
    Component: NotFound,
    waitForTitlePrefix: false,
  },
];

const Users = ({ router: { location } }) => {
  const { pathname } = useLocation();
  const { state } = location;
  const { sessionId, type } = state || {};
  const { onChangeColors } = usePatternBackground();
  const queryParams = new URLSearchParams(location.search);
  const groupSessionId = queryParams.get("sessionId");

  useEffect(() => {
    if (pathname.includes("content-lists")) {
      onChangeColors(BluePattern.color.pattern.value, true);
    } else if (pathname.includes("/meeting")) {
      onChangeColors(BluePattern.color.pattern.value, false);
    } else if (pathname.startsWith("/user/schedule")) {
      onChangeColors(OrangePattern.color.pattern.value, true);
    } else if (pathname.startsWith("/user/woneindex/energy")) {
      onChangeColors(BluePattern.color.pattern.value, true);
    } else if (pathname.startsWith("/user/woneindex/activity")) {
      onChangeColors(RedPattern.color.pattern.value, true);
    } else if (pathname.startsWith("/user/woneindex/resilience")) {
      onChangeColors(OrangePattern.color.pattern.value, true);
    } else if (pathname.startsWith("/user/articles")) {
      onChangeColors(BluePattern.color.pattern.value, true);
    } else if (pathname.startsWith("/user/profile")) {
      onChangeColors(PinkPattern.color.pattern.value, true);
    } else if (pathname.startsWith("/user/chat")) {
      onChangeColors(null, false, styles["bg-bone-100"], false);
    } else {
      onChangeColors(null, false, styles["bg-bleached-silk"], false); // I don't like this
    }
  }, [pathname, onChangeColors]);

  return (
    <BiometricsModalProvider>
      <ContentModalManagerProvider>
        {!location?.state?.zoomMtgNumber &&
          !location?.pathname.includes("meeting/feedback") &&
          !location.pathname.includes("feedback") && <SNavbar />}
        <Routes>
          {/* Redirect deprecated routes to discover page with modal params */}
          <Route
            path="sessions/group/:session_id"
            element={<SessionGroupRedirect />}
          />
          <Route
            path="recordings/:recordingId"
            element={<RecordingRedirect />}
          />
          {UserRoutes.map((Routes, index) => {
            if (
              Routes?.Path === "sessions/:sessionType/:sessionId/meeting" &&
              !location.state
            ) {
              return (
                <Route
                  key={index}
                  path="*"
                  element={
                    <Navigate
                      to={location.pathname.replace("/meeting", "")}
                      state={{ from: location }}
                      replace
                    />
                  }
                />
              );
            }
            if (
              Routes.Path ===
              "sessions/:sessionType/:sessionId/meeting/feedback"
            ) {
              return (
                <Route
                  key={index}
                  path="sessions/:sessionType/:sessionId/meeting/feedback"
                  element={
                    <SessionFeedbackProvider
                      sessionId={groupSessionId}
                      type="LIVE"
                    >
                      <PageProvider
                        title={Routes.Title}
                        waitForPrefix={Routes?.waitForTitlePrefix}
                      >
                        <Routes.Component location={location} />
                      </PageProvider>
                    </SessionFeedbackProvider>
                  }
                />
              );
            }
            if (
              Routes?.Path === "recordings/:recordingId/feedback" &&
              location.state
            ) {
              return (
                <Route
                  key={index}
                  path="recordings/:recordingId/feedback"
                  exact={Routes?.Exact}
                  element={
                    <SessionFeedbackProvider sessionId={sessionId} type={type}>
                      <PageProvider
                        title={Routes.Title}
                        waitForPrefix={Routes?.waitForTitlePrefix}
                      >
                        <Routes.Component location={location} />
                      </PageProvider>
                    </SessionFeedbackProvider>
                  }
                />
              );
            }
            if (
              Routes?.Path === "recordings/:recordingId/feedback" &&
              !location.state
            ) {
              return (
                <Route
                  key={index}
                  path="*"
                  element={
                    <Navigate
                      to={location.pathname.replace("/recordings", "")}
                      state={{ from: location }}
                      replace
                    />
                  }
                />
              );
            }
            return (
              <Route
                key={index}
                path={Routes.Path}
                exact={Routes?.Exact}
                element={
                  <PageProvider
                    title={Routes.Title}
                    waitForPrefix={Routes?.waitForTitlePrefix}
                  >
                    <Routes.Component location={location} />
                  </PageProvider>
                }
              />
            );
          })}
        </Routes>
        <ContentModalRouter />
        <FeedbackWidget />
      </ContentModalManagerProvider>
    </BiometricsModalProvider>
  );
};

export default withRouter(Users);
